import React from 'react';
import { privacy, spec } from '../data/siteContent';

/**
 * A colophon rather than a feature grid: the numbers a reader would otherwise
 * have to install the app to find out, set as a plain specification table.
 */
const SpecSection: React.FC = () => {
  return (
    <section className="section-y">
      <div className="shell">
        <div className="grid gap-14 lg:grid-cols-12 lg:gap-gutter">
          <div className="lg:col-span-5">
            <p className="kicker-action">Specification</p>
            <h2 className="display-lg mt-5 text-[2.25rem] sm:text-[2.6rem]">
              The numbers, before you download.
            </h2>
            <p className="prose-note mt-6 max-w-sm">
              Reading settings are set once and remembered. These are the ranges the app actually
              ships with.
            </p>
          </div>

          <dl className="lg:col-span-7">
            {spec.map((row) => (
              <div
                key={row.label}
                className="grid grid-cols-[10rem_1fr] gap-4 border-t border-ink/12 py-3.5 first:border-t-0 sm:grid-cols-[12rem_1fr] sm:gap-6"
              >
                <dt className="kicker pt-1">{row.label}</dt>
                <dd className="font-heading text-[0.9375rem] text-text sm:text-base">{row.value}</dd>
              </div>
            ))}
          </dl>
        </div>

        {/* Privacy reads as a consequence of the architecture above, so it sits
            in the same block rather than getting a section of its own. */}
        <div className="mt-gutter border-t-2 border-ink pt-10">
          <div className="flex flex-wrap items-baseline justify-between gap-4">
            <h3 className="display-lg text-[1.75rem] sm:text-[2.25rem]">{privacy.title}</h3>
            <p className="kicker-action">{privacy.eyebrow}</p>
          </div>

          <dl className="mt-9 grid gap-px bg-ink/12 sm:grid-cols-2 lg:grid-cols-4">
            {privacy.points.map((point) => (
              <div key={point.title} className="bg-background p-6">
                <dt className="display-sm text-lg">{point.title}</dt>
                <dd className="prose-note mt-2.5 text-[0.9375rem]">{point.body}</dd>
              </div>
            ))}
          </dl>
        </div>
      </div>
    </section>
  );
};

export default SpecSection;
